<template>
  <Popup
    v-model:show="popVisible"
    position="bottom"
    height="100%"
  >
    <div class="popup-content">
      <!-- 关闭按钮 -->
      <img
        @click="popVisible = false"
        class="close-icon"
        src="@/assets/images/close-icon.svg"
        alt=""
      >
      <div class="fixed-area">
        <div class="selected-variant">
          <div
            @click="showCarouselImagePreview = true"
            class="sku-image-container"
          >
            <Image
              v-if="checkedSku?.skuImageUrl"
              class="sku-image"
              :src="checkedSku?.skuImageUrl"
            />
            <img
              v-else
              class="sku-image"
              src="@/assets/empty-image.svg"
              alt=""
            >
            <div class="preview">
              <Icon
                class="icon"
                name="move-l"
              />
            </div>
          </div>
          <div class="variant-info">
            <div class="title">
              Select Variants:
            </div>
            <div class="attribute">
              {{ checkedSku?.valueTrans }}
            </div>
            <div class="price-range">
              <IntlCurrency :currency="currencyData.targetCurrency" />
              <span>{{ bankersRoundWithMax(priceRangeList[priceRangeList.length - 1]?.price * currencyData.rate, 0.01) }}</span>
              -
              <span>{{ bankersRoundWithMax(priceRangeList[0]?.price * currencyData.rate, 0.01) }}</span>
            </div>
            <div class="min-order">
              <span class="prefix">/Piece</span>
              Min.Order: 1 Piece
            </div>
          </div>
        </div>
        <PriceRange
          :list="priceRangeList"
          :open-mini="true"
        />
      </div>

      <!-- sku变体 -->
      <div class="variants">
        <div class="title">
          Select Variants and Quantity
        </div>
        <div class="sub-title">
          Variants ({{ skuImages[0]?.attributeNameTrans }}):
          <span class="suffix">{{ checkedSku?.valueTrans }}</span>
        </div>
        <div
          ref="skuListRef"
          :class="{ 'single-row': skuImages.length <= 12 }"
          class="sku-list"
        >
          <template v-if="skuImages.length > 12">
            <div class="sku-row">
              <div
                v-for="(sku, i) in topRow"
                @click="handleCheckSku(sku, i * 2)"
                :key="sku.skuId"
                :class="['sku-list-item', { active: i * 2 === activeIndex }]"
              >
                <Image
                  v-if="sku.skuImageUrl"
                  class="image"
                  :src="sku.skuImageUrl"
                />
                <img
                  v-else
                  class="image"
                  src="@/assets/empty-image.svg"
                  alt=""
                >
                <div
                  v-if="sku.quantity"
                  class="quantity"
                >
                  <span class="prefix">x</span>
                  {{ sku.quantity }}
                </div>
              </div>
            </div>
            <div class="sku-row">
              <div
                v-for="(sku, i) in bottomRow"
                @click="handleCheckSku(sku, i * 2 + 1)"
                :key="sku.skuId"
                :class="['sku-list-item', { active: i * 2 + 1 === activeIndex }]"
              >
                <Image
                  v-if="sku.skuImageUrl"
                  class="image"
                  :src="sku.skuImageUrl"
                />
                <img
                  v-else
                  class="image"
                  src="@/assets/empty-image.svg"
                  alt=""
                >
                <div
                  v-if="sku.quantity"
                  class="quantity"
                >
                  <span class="prefix">x</span>
                  {{ sku.quantity }}
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(sku, i) in skuImages"
              @click="handleCheckSku(sku, i)"
              :key="sku.skuId"
              :class="['sku-list-item', { active: i === activeIndex }]"
            >
              <Image
                v-if="sku.skuImageUrl"
                class="image"
                :src="sku.skuImageUrl"
              />
              <img
                v-else
                class="image"
                src="@/assets/empty-image.svg"
                alt=""
              >
              <div
                v-if="sku.quantity"
                class="quantity"
              >
                <span class="prefix">x</span>
                {{ sku.quantity }}
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- 属性 -->
      <div class="sku-attributes">
        <div class="sku-attributes-header">
          <div class="header-left">
            {{ skuImages[activeIndex]?.singleAttr ? 'Quantity:' : currentAttributesList[0]?.attributeNameTrans }}
            <template v-if="!skuImages[activeIndex]?.singleAttr">
              ({{ currentAttributesList.length }}):
            </template>
            <span class="min-order"> Min.Order: {{ data?.minOrderQuantity }} PCS</span>
          </div>
          <div
            @click="clearAttributes"
            class="header-right"
          >
            Clear all
          </div>
        </div>

        <div class="sku-attributes-list">
          <div
            v-for="(item, index) in currentAttributesList"
            :key="index"
            class="sku-attributes-list-item"
          >
            <template v-if="item.singleAttr">
              <div class="single-attirbute">
                <NumberInput
                  class="number-input"
                  v-model="item.quantity"
                  :disabled-minus="item.quantity <= 0"
                  :disabled-plus="item.amountOnSale === 0 || item.quantity >= item.amountOnSale"
                  :min="0"
                  :max="item.amountOnSale"
                  :step="item.bundleQuantity"
                  @change="handleNumberInputChange(item)"
                />
                <div class="stock-count">
                  {{ item.amountOnSale > 999 ? '999+' : item.amountOnSale }} in stock
                </div>
              </div>
            </template>
            <template v-else>
              <div
                :title="item.valueTrans"
                :class="{ checked: item.checked }"
                class="item-left"
              >
                {{ item.valueTrans }}
              </div>
              <div class="item-right">
                <div class="stock-count">
                  {{ item.amountOnSale > 999 ? '999+' : item.amountOnSale }} in stock
                </div>
                <NumberInput
                  class="number-input"
                  v-model="item.quantity"
                  :disabled-minus="item.quantity <= 0"
                  :disabled-plus="item.amountOnSale === 0 || item.quantity >= item.amountOnSale"
                  :min="0"
                  :max="item.amountOnSale"
                  :step="item.bundleQuantity"
                  @change="handleNumberInputChange(item)"
                />
              </div>
            </template>
          </div>
        </div>
      </div>

      <MoreService />

      <!-- 地址相关 -->
      <Delivery
        @re-cacl-ship-fee="handleReCalcShipFee"
        :min-delivery-time="minDeliveryTime"
        :max-delivery-time="maxDeliveryTime"
      />

      <FixedFooter
        ref="fixedFooterRef"
        :data="data"
        :is-processing="isProcessing"
      />
    </div>

    <CarouselImagePreview
      v-model:show="showCarouselImagePreview"
      :images="[...swiperImages, ...descImages]"
      :products-length="productImages.length"
      :styles-length="skuImages.length"
      :index="activeIndex"
      :variant-images="variantImages"
      :desc-images="descImages"
      @find-similar="(imageUrl) => {
        showCarouselImagePreview = false
        popVisible = false
        handleFind('similar', imageUrl)
      }"
    />
  </Popup>
</template>

<script setup>
import { ref } from 'vue'
import { Popup } from '@/components/Popup'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import Icon from '@/components/Icon/Icon.vue'
import PriceRange from '../PriceRange.vue'
import { useProductDetail } from '../../../hooks/useProductDetail'
import NumberInput from '@/components/NumberInput/index.vue'
import { debounce, bankersRoundWithMax, buriedPointUtil } from '@/utils/utils'
import { fetchData } from '@/utils/fetch'
import Delivery from '../Delivery.vue'
import FixedFooter from './FixedFooter.vue'
import { useUserStore } from '@/pinia/user'
import CarouselImagePreview from '../H5Carousel/CarouselImagePreview.vue'
import { useRouter, useRoute } from 'vue-router'
import { Image } from '@/components/Image'
import { useCalcShip } from '../../../hooks/useCalcShip'
import MoreService from './MoreService.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  descImages: {
    type: Array,
    default: () => []
  }
})

const {
  skuAttributes,
  swiperImages,
  productImages,
  variantImages,
  formatImageList,
  initSwiperImages,
  formatPriceRangeList
} = useProductDetail()

const { minDeliveryTime, maxDeliveryTime } = useCalcShip()

const popVisible = defineModel()

const userStore = useUserStore()

const currencyStore = useCurrencyStore()

const router = useRouter()

const route = useRoute()

const priceRangeList = ref([])

const activeIndex = ref(0)

const checkedSku = ref(null)

const skuImages = ref([])

const skuCartStatus = ref([])

const isProcessing = ref(false)

const showCarouselImagePreview = ref(false)

const skuListRef = ref(null)

const currencyData = computed(() => currencyStore.current)

const currentAttributesList = computed(() => {
  if (!checkedSku.value) return []

  const valueTrans = checkedSku.value.valueTrans
  return skuAttributes.value.filter(item => item.tag === valueTrans)
})

const topRow = computed(() => skuImages.value.filter((_, index) => index % 2 === 0))
const bottomRow = computed(() => skuImages.value.filter((_, index) => index % 2 === 1))

watch(() => props.data, async (value) => {
  if (value) {
    skuImages.value = formatImageList(value)
    initSwiperImages(value)
    if (userStore.isLogged) {
      await getSkuCartStatus()
    }
    handleDefaultAction()
  }
})

watch(popVisible, value => {
  if (value) {
    nextTick(() => {
      skuListRef.value.scrollTo({
        top: 0,
        left: 63 * activeIndex.value / 2,
        behavior: 'smooth'
      })
    })
  }
})

const handleQuantityChange = debounce((item) => {
  setImagesQuantity(item)
  handleCheckStatus(item)
}, 200)

const handleNumberInputChange = (item) => {
  let val = calcBundleQuantity(item)

  if (val > item.amountOnSale) {
    val = item.amountOnSale
  }
  item.quantity = val
  handleQuantityChange(item)
}

const setImagesQuantity = (item) => {
  const quantity = currentAttributesList.value.reduce((pre, cur) => {
    return pre + cur.quantity
  }, 0)

  skuImages.value.forEach(v => {
    if (v.valueTrans === item.tag) {
      v.quantity = quantity
    }
  })
}

/**
 * 捆绑数量算法， 与 购物车 逻辑存在差异
 * 1. 当数量不为 0 时，计算后的数量最小为 bundleQuantity
 */
const calcBundleQuantity = (data) => {
  const bundleQuantity = +data.bundleQuantity
  const halfBundle = bundleQuantity / 2
  let quantity = +data.quantity
  if (quantity > 0) {
    quantity = (Math.floor((quantity + halfBundle) / bundleQuantity)) * bundleQuantity || bundleQuantity
  }
  return quantity
}

const handleCheckStatus = (item) => {
  skuAttributes.value.forEach(v => {
    v.checked = false
  })
  if (item.quantity > 0) {
    item.checked = true
  }
}

const clearAttributes = () => {
  skuAttributes.value.forEach(item => {
    item.checked = false
    item.quantity = 0
  })
  skuImages.value.forEach(item => {
    item.quantity = 0
  })
}

const handleCheckSku = (item, index) => {
  checkedSku.value = item
  activeIndex.value = index
  isProcessing.value = skuCartStatus.value.includes(String(item.skuId))
  getPriceRangeList(item)
}

// 默认选中以及默认加购
const handleDefaultAction = () => {
  // 选中价格最低的sku
  let index = 0
  let firstPrice = skuImages.value[0].price
  skuImages.value.forEach((item, _index) => {
    if (Number(item.price) < Number(firstPrice)) {
      firstPrice = item.price
      index = _index
    }
  })

  handleCheckSku(skuImages.value[index], index)

  // 找到当前sku对应的规格
  const valueTrans = checkedSku.value.valueTrans
  const attributes = skuAttributes.value.filter(item => item.tag === valueTrans)

  // 设置第二个区间价的数量
  const priceRangeList = checkedSku.value.priceRangeList
  const quantity = Math.max((priceRangeList[1] ?? priceRangeList[0]).startQuantity, checkedSku.value.bundleQuantity)
  checkedSku.value.quantity = quantity
  attributes[0].quantity = quantity
  attributes[0].checked = true
}

const getPriceRangeList = async (sku) => {
  const { priceRangeList: list } = await formatPriceRangeList(props.data.offerId, sku, props.data.categoryId)
  priceRangeList.value = list
}

const fixedFooterRef = ref()
const handleReCalcShipFee = () => {
  getPriceRangeList(checkedSku.value)
}

const getSkuCartStatus = async () => {
  const params = {
    spuId: props.data.offerId,
    skuIds: props.data.productSkuInfos.map(item => item.skuId)
  }
  const { data } = await fetchData('/appb/b2b/cart/getPendingSkuBySpu', {
    method: 'post',
    body: JSON.stringify(params)
  })
  skuCartStatus.value = data || []
}

const handleFind = (type, imageUrl) => {
  if (type === 'similar') {
    buriedPointUtil({ eventId: 'MPOP201' })
  } else {
    buriedPointUtil({ eventId: 'MPOP202' })
  }

  sessionStorage.setItem(`currentMainImage_${props.data.offerId}`, imageUrl)

  nextTick(() => {
    const url = `/search?offerId=${props.data.offerId}&type=${type}`
    if (route.fullPath.includes('imageId')) {
      router.replace(url)
    } else {
      router.push(url)
    }
  })
}

</script>

<style lang='less' scoped>
.popup-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: calc(100% - 8px);
  padding: 0 12px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  padding-bottom: 166px;
  overflow-y: scroll;
  overflow-x: hidden;
  .close-icon {
    position: fixed;
    top: 18px;
    right: 12px;
    width: 28px;
    height: 28px;
    z-index: 100;
  }

  .fixed-area {
    position: sticky;
    top: 0;
    background-color: white;
    width: calc(100% + 24px);
    margin-left: -12px;
    padding: 0 12px;
    padding-top: 16px;
    z-index: 99;
  }

  .selected-variant {
    display: flex;
    align-items: center;
    gap: 12px;
    .sku-image-container {
      position: relative;
      .sku-image {
        width: 80px;
        height: 80px;
        border-radius: 8px;
      }
      .preview {
        position: absolute;
        top: 4px;
        right: 4px;
        color: white;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #14141440;
        transform: rotate(45deg);
      }
    }
    .variant-info {
      .title {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }
      .attribute {
        margin-top: 2px;
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }
      .price-range {
        color: #232323;
        font-size: 20px;
        font-family: mon-700;
        margin-top: 2px;
      }
      .min-order {
        color: #6E717A;
        font-size: 10px;
        font-family: mon-500;
        margin-top: 4px;
        .prefix {
          margin-right: 8px;
        }
      }
    }
  }

  .variants {
    padding-top: 20px;
    margin-top: 20px;
    border-top: 1px solid #ebf1f5;
    .title {
      color: #232323;
      font-size: 14px;
      font-family: mon-700;
      line-height: 18px;
    }
    .sub-title {
      margin-top: 16px;
      color: #232323;
      font-size: 12px;
      font-family: mon-700;
      .suffix {
        font-family: mon-500;
      }
    }
    .sku-list {
      width: calc(100% + 12px);
      height: 124px;
      margin-top: 8px;
      overflow-x: scroll;
      padding: 2px;

      &.single-row {
        display: flex;
        gap: 10px;
        height: 70px;
      }

      .sku-row {
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      /* 滚动条整体 */
      &::-webkit-scrollbar {
        width: 0;
        height: 2px;
      }

      /* 滚动条轨道（滑轨） */
      &::-webkit-scrollbar-track {
        background: #f8f8f8;  /* 滑轨颜色 */
        border-radius: 1px;
        height: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ebebeb; /* 设置滑块颜色 */
        border-radius: 1px;
        height: 2px;
      }

      .sku-list-item {
        position: relative;
        flex-shrink: 0;
        width: 53px;
        height: 53px;
        border-radius: 50%;
        padding: 2px;
        border: 1px solid #ebf1f5;

        &.active {
          outline: 2px solid #052784;
        }
        &.placeholder {
          visibility: hidden;
          pointer-events: none;
        }
        .image {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        .quantity {
          position: absolute;
          top: -3px;
          right: -4px;
          height: 16px;
          padding: 0 6px;
          background-color: #009DE0;
          border-radius: 8px;
          color: white;
          font-size: 12px;
          font-family: mon-500;
          display: flex;
          align-items: center;
          outline: 1.5px solid white;
          .prefix {
            font-size: 10px;
          }
        }
      }
    }
  }

  .sku-attributes {
    margin-top: 16px;
    padding-bottom: 2px;
    border-bottom: 1px solid #ebf1f5;

    .sku-attributes-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .header-left {
        color: #232323;
        font-size: 14px;
        font-family: mon-700;
        .min-order {
          font-size: 11px;
          font-family: mon-500;
        }
      }
      .header-right {
        position: relative;
        height: 14px;
        color: #6E717A;
        font-size: 11px;
        font-family: mon-500;
        text-decoration: underline;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        &:hover {
          color: var(--link-hover-color);
        }

        &::before {
          content: '';
          display: block;
          position: relative;
          top: 1px;
          left: -8px;
          height: 8px;
          width: 1px;
          background-color: #DFDFDF;
        }
      }
    }
    .sku-attributes-list {

    }
    .sku-attributes-list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      margin-bottom: 18px;
      padding-left: 4px;

      .item-left {
        height: 24px;
        padding: 4px 12px;
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        border-radius: 4px;
        background-color: #F8F8F8;
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.checked {
          outline: 2px solid #052784;
          outline-offset: 2px;
        }
      }
      .item-right {
        display: flex;
        align-items: center;
        gap: 12px;
        .stock-count {
          color: #B2B7C2;
          font-size: 11px;
          font-family: mon-500;
        }
        .number-input {
          width: 96px;
          height: 32px;
          ::v-deep(.round-button) {
            width: 32px;
            height: 32px;
          }
        }
      }

      .single-attirbute {
        display: flex;
        align-items: center;
        gap: 12px;
        .number-input {
          width: 108px;
          height: 32px;
          ::v-deep(.round-button) {
            width: 32px;
            height: 32px;
          }
        }
        .stock-count {
          color: #B2B7C2;
          font-size: 11px;
          font-family: mon-500;
        }
      }
    }
  }
}

.price-range-container {
  padding: 0;
}
</style>
